var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTemplates = function SvgTemplates(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.467 0H1.675C.741 0 0 .834 0 1.885v13.23C0 16.166.741 17 1.675 17h11.76c.934 0 1.675-.834 1.675-1.885V1.885C15.142.834 14.401 0 13.467 0ZM11.18 13.484H3.963c-.355 0-.645-.326-.645-.725 0-.399.29-.725.645-.725h7.216c.355 0 .645.326.645.725 0 .399-.29.725-.644.725Zm0-4.24H3.963c-.355 0-.645-.327-.645-.726 0-.399.29-.725.645-.725h7.216c.355 0 .645.326.645.725 0 .399-.29.725-.644.725Zm0-4.278H3.963c-.355 0-.645-.326-.645-.725 0-.399.29-.725.645-.725h7.216c.355 0 .645.326.645.725 0 .399-.29.725-.644.725Z",
    fill: "currentColor"
  })));
};
export default SvgTemplates;